module.exports = __webpack_public_path__ + "static/media/sg14sj.12f35350.png";